import { jsonFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { BOOKINGS_URL } from "./api-url.constants";
import { CreateBookingApiDto } from "./dtos";

export const createBooking = async (booking: CreateBookingApiDto): Promise<string> => {
  const result = await jsonFetch<{
    data?: { _id?: string; id?: string };
    _id?: string;
    id?: string;
  }>(BOOKINGS_URL, {
    method: API_METHODS.POST,
    body: JSON.stringify(booking),
  });

  const bookingId = result.data?._id ?? result.data?.id ?? result._id ?? result.id;

  if (!bookingId) {
    throw new Error("Missing booking id in create booking response");
  }

  return bookingId;
};
